<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row v-for="(v, idx) of value" :key="idx" no-gutters>
        <v-col cols="10">
          <data-input
            v-if="descriptors.valueKey"
            v-model="value[idx][descriptors.valueKey]"
            v-bind="{
              ...$props,
              ...$attrs,
              ...editInputProps,
              clearable: true,
              dataType: descriptors.allowed_data_type,
            }"
            @input="onInput"
          />
          <data-input
            v-else
            v-model="value[idx]"
            v-bind="{
              ...$props,
              ...$attrs,
              ...editInputProps,
              clearable: true,
              dataType: descriptors.allowed_data_type,
            }"
            @input="onInput"
          />
        </v-col>
        <v-col cols="2" class="text-left pt-2 pl-2" align-self="start">
          <v-icon color="rgba(0,0,0,0.7)" size="20" @click="deleteValue(idx)">
            mdi-delete
          </v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters align="center">
        <v-col cols="10">
          <data-input
            v-model="newValue"
            v-bind="{
              ...$props,
              ...$attrs,
              ...newInputProps,
              rules: undefined,
              dataType: descriptors.allowed_data_type,
            }"
          />
        </v-col>
        <v-col cols="2" class="text-left pt-2 pl-2" align-self="start">
          <v-icon color="success" @click="addNewValue" :disabled="!newValueValid">
            mdi-check
          </v-icon>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'DataInputDict',
  components: {
    DataInput: () => import('@/components/DataInput'),
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    descriptors: {
      required: false,
      type: Object,
    },
    editInputProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    newInputProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    newValue: undefined,
    newValueValid: false,
  }),
  methods: {
    addNewValue() {
      this.$set(
        this.value,
        this.value.length,
        this.descriptors.valueKey ? { [this.descriptors.valueKey]: this.newValue } : this.newValue
      );
      this.onInput();
      this.$nextTick(() => {
        this.newValue = undefined;
        this.$forceUpdate();
      });
    },
    deleteValue(idx) {
      this.$delete(this.value, idx);
      this.onInput();
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    onInput() {
      this.$emit('input', this.value);
    },
  },
  watch: {
    newValue: {
      handler(nV) {
        this.newValueValid = this.$attrs.rules.every(rule => rule(nV) === true);
      },
      immediate: true,
    },
  },
};
</script>
